module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ZBoMe8/tc-custom/9781497623163.jpg?1733028377313",
      "alt": "This image is the cover for the book Castle for Rent, Castle Perilous"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Castle for Rent, Castle Perilous\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("When the king of a magical castle ventures into the realm of the dead, creatures of all kinds vie for the throne in the sequel to "), _c('i', [_vm._v("Castle Perilous")]), _vm._v(". ")]), _c('br'), _c('br'), _vm._v(" Who will claim the throne now that Lord Incarnadine, King of the Realms Perilous, is dead? Under a mysterious spell cast by a mischief-maker, all of Castle Perilous's 144,000 creatures of curiosity clamor for the crown. Outside of the castle's coveting fray, Gene flies off with an adventurous Amazon in supernatural manifestation and Lord Inky explores the dark mysteries that lurk in the realm of the dead! \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John DeChancie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("John DeChancie is a popular author of numerous science fiction and fantasy novels, including the hugely entertaining Castle series and the Starrigger trilogy. He grew up near Pittsburgh, Pennsylvania, and now lives in Los Angeles, California.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0